// Estimated shipping day: today plus business days, skipping weekends ("October 21st").
function shipDate(days) {
  const date = new Date();
  while (days > 0) { date.setDate(date.getDate() + 1); if (date.getDay() % 6 !== 0) days -= 1; }
  const n = date.getDate();
  const suffix = n % 10 === 1 && n !== 11 ? 'st' : n % 10 === 2 && n !== 12 ? 'nd' : n % 10 === 3 && n !== 13 ? 'rd' : 'th';
  return date.toLocaleDateString('en-US', { month: 'long' }) + ' ' + n + suffix;
}
// Inline shipping-day lines in page sections.
document.querySelectorAll('[data-ship-inline]').forEach((el) => {
  const days = parseInt(el.dataset.shipDays, 10) || 0;
  const out = el.querySelector('[data-ship-date]');
  if (!days || !out) return;
  out.textContent = shipDate(days);
  el.hidden = false;
});
// Cart drawer copy of the shipping day, using the bundle picker's days and wording when present.
(() => {
  const cdShip = document.querySelector('[data-cd-ship]');
  if (!cdShip) return;
  const src = document.querySelector('.hb-ship[data-ship-days]');
  const days = src ? parseInt(src.dataset.shipDays, 10) || 0 : 3;
  if (days <= 0) return;
  const label = src && src.querySelector('[data-ship-date]')?.previousSibling?.textContent.trim();
  if (label) cdShip.querySelector('[data-ship-label]').textContent = label;
  const origin = src && src.querySelector('[data-ship-origin]');
  const cdOrigin = cdShip.querySelector('[data-ship-origin]');
  if (origin && cdOrigin) { cdOrigin.innerHTML = origin.innerHTML.replace('Ships from the USA', 'FREE shipping from the USA'); cdOrigin.hidden = false; }
  cdShip.querySelector('[data-ship-date]').textContent = shipDate(days);
  cdShip.hidden = false;
})();

(() => {
  const STAR = '<svg viewBox="0 0 24 24"><path d="M12 2l3 6.6 7.2.8-5.4 4.9 1.5 7.1L12 17.8 5.7 21.4l1.5-7.1L1.8 9.4 9 8.6z"/></svg>';
  document.querySelectorAll('[data-stars]').forEach((el) => {
    el.innerHTML = STAR.repeat(Number(el.dataset.stars) || 5);
  });

  // Free-shipping countdown.
  // "visitor" mode: starts on the visitor's first page view and is remembered, so reloading never restarts it.
  // While it runs, checkout applies the free-shipping code; after it ends, standard shipping applies.
  const timer = document.getElementById('timer');
window.drFreeShip = { active: true, code: '' };
  if (timer) {
    let end;
    if (timer.dataset.mode === 'visitor') {
      const KEY = 'dr_fs_start';
      let start = 0;
      try { start = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
      if (!start) { start = Date.now(); try { localStorage.setItem(KEY, String(start)); } catch (e) {} }
      end = start + (parseFloat(timer.dataset.minutes) || 10) * 60000;
    } else {
      end = new Date(timer.dataset.end).getTime();
    }
    const pad = (n) => String(n).padStart(2, '0');
    const set = (id, v) => { document.getElementById(id).textContent = v; };
    const tick = () => {
      const left = end - Date.now();
      if (!(left > 0)) {
        window.drFreeShip = { active: false, code: '' };
        timer.style.display = 'none';
        const text = document.querySelector('#barText > span.bar-long') || document.querySelector('#barText > span:last-child');
        document.querySelectorAll('#barText .bar-long, #barText .bar-short').forEach((t) => { t.textContent = timer.dataset.expiredText; });
        if (text && !text.classList.contains('bar-long')) text.textContent = timer.dataset.expiredText;
        document.dispatchEvent(new CustomEvent('dr:freeship'));
        return;
      }
      window.drFreeShip = { active: true, code: timer.dataset.code || '' };
      // Attach the free-shipping code to the cart session once, so every checkout path gets it.
      if (timer.dataset.code && !window.drFreeShipApplied) {
        window.drFreeShipApplied = true;
        let done = false;
        try { done = sessionStorage.getItem('dr_fs_applied') === timer.dataset.code; } catch (e) {}
        if (!done) {
          fetch('/discount/' + encodeURIComponent(timer.dataset.code), { credentials: 'same-origin' })
            .then(() => { try { sessionStorage.setItem('dr_fs_applied', timer.dataset.code); } catch (e) {} })
            .catch(() => {});
        }
      }
      const days = Math.floor(left / 8.64e7);
      document.getElementById('dBox').style.display = days ? '' : 'none';
      document.getElementById('dSep').style.display = days ? '' : 'none';
      set('tD', days);
      set('tH', pad(Math.floor(left / 3.6e6) % 24));
      set('tM', pad(Math.floor(left / 6e4) % 60));
      set('tS', pad(Math.floor(left / 1e3) % 60));
      setTimeout(tick, 1000);
    };
    tick();
  }

  // Gallery
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const thumbs = g.querySelectorAll('.thumb');
    const slides = g.querySelectorAll('.slide');
    thumbs.forEach((t) => t.addEventListener('click', () => {
      thumbs.forEach((x) => x.classList.remove('on'));
      slides.forEach((x) => x.classList.remove('on'));
      t.classList.add('on');
      slides[t.dataset.s]?.classList.add('on');
    }));
  });

  // Mobile gallery dots: follow the swipe position and jump to a slide on tap.
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const track = g.querySelector('[data-swipe]');
    const slides = track ? [...track.querySelectorAll('.slide')] : [];
    if (slides.length < 2) return;
    const dots = document.createElement('div');
    dots.className = 'g-dots';
    dots.setAttribute('role', 'group');
    dots.setAttribute('aria-label', 'Gallery images');
    slides.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + slides.length);
      b.addEventListener('click', () => track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }));
      dots.appendChild(b);
    });
    track.closest('.main-frame')?.after(dots);
    const set = () => {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.querySelectorAll('button').forEach((b, j) => b.setAttribute('aria-current', String(j === i)));
    };
    track.addEventListener('scroll', set, { passive: true });
    set();
  });

  // One-time / subscribe toggle: subscription is sent only when its input is enabled.
  document.querySelectorAll('[data-plans]').forEach((wrap) => {
    const buttons = wrap.querySelectorAll('.toggle button');
    buttons.forEach((b) => b.addEventListener('click', () => {
      buttons.forEach((x) => x.classList.toggle('on', x === b));
      const sub = b.dataset.mode === 'sub';
      wrap.classList.toggle('mode-sub', sub);
      wrap.querySelector('.toggle')?.classList.toggle('is-sub', sub);
      wrap.querySelectorAll('[data-sub-input]').forEach((i) => { i.disabled = !sub; });
      buttons.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    }));
    // "Switch to subscribe" link inside the gifts panel of a one-time card.
    wrap.querySelectorAll('[data-switch-sub]').forEach((b) => b.addEventListener('click', () => {
      wrap.querySelector('.toggle button[data-mode="sub"]')?.click();
    }));
    wrap.querySelectorAll('[data-plan-form]').forEach((f) => f.addEventListener('submit', () => {
      f.querySelector('button')?.setAttribute('aria-busy', 'true');
    }));
  });

  // Hero bundle picker: the subscription plan follows the selected bundle.
  document.querySelectorAll('[data-buybox]').forEach((box) => {
    const sp = box.querySelector('[data-hb-sp]');
    box.querySelectorAll('input[type="radio"][name="id"]').forEach((r) => r.addEventListener('change', () => {
      if (sp && r.checked) sp.value = r.dataset.sp || '';
    }));
    // Subscribe checkbox: subscription is sent only while it is ticked.
    const subBox = box.querySelector('[data-hb-sub]');
    subBox?.addEventListener('change', () => {
      box.classList.toggle('mode-sub', subBox.checked);
      box.querySelectorAll('[data-sub-input]').forEach((i) => { i.disabled = !subBox.checked; });
    });
    // One-time / subscribe plan cards with quantity and a price on the button.
    const modes = box.querySelectorAll('[data-hb-mode]');
    if (modes.length) {
      const qty = box.querySelector('[data-qty-input]');
      const now = box.querySelector('[data-cta-now]');
      const was = box.querySelector('[data-cta-was]');
      const fmt = (c) => new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(c / 100);
      const update = () => {
        const sel = [...modes].find((m) => m.checked);
        if (!sel) return;
        const sub = sel.value === 'sub';
        box.classList.toggle('mode-sub', sub);
        box.querySelectorAll('[data-sub-input]').forEach((i) => { i.disabled = !sub; });
        const n = Math.min(10, Math.max(1, parseInt(qty?.value, 10) || 1));
        if (now) now.textContent = fmt(Number(sel.dataset.price) * n);
        if (was) was.textContent = fmt(Number(sel.dataset.compare) * n);
      };
      modes.forEach((m) => m.addEventListener('change', update));
      box.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => {
        qty.value = Math.min(10, Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.qty)));
        update();
      }));
      qty?.addEventListener('change', update);
      update();
    }
    // Sale countdown to the merchant's fixed end date; hidden once it has passed.
    const deal = box.querySelector('[data-deal-end]');
    const end = deal ? new Date(deal.dataset.dealEnd).getTime() : NaN;
    if (deal && end > Date.now()) {
      const left = deal.querySelector('[data-deal-left]');
      const pad = (n) => String(n).padStart(2, '0');
      const tickDeal = () => {
        const ms = end - Date.now();
        if (ms <= 0) { deal.hidden = true; clearInterval(timerId); return; }
        const t = Math.floor(ms / 1000);
        const d = Math.floor(t / 86400);
        left.textContent = (d ? d + 'd ' : '') + pad(Math.floor(t / 3600) % 24) + ':' + pad(Math.floor(t / 60) % 60) + ':' + pad(t % 60);
      };
      const timerId = setInterval(tickDeal, 1000);
      tickDeal();
      deal.hidden = false;
    }
    // Estimated shipping day: today plus the merchant's business days, skipping weekends.
    const ship = box.querySelector('[data-ship-days]');
    if (ship) {
      ship.querySelector('[data-ship-date]').textContent = shipDate(parseInt(ship.dataset.shipDays, 10) || 0);
      ship.hidden = false;
    }
  });

  // Testimonial carousel arrows
  document.querySelectorAll('[data-tm]').forEach((sec) => {
    const track = sec.querySelector('[data-tm-track]');
    const prev = sec.querySelector('[data-tm-prev]');
    const next = sec.querySelector('[data-tm-next]');
    if (!track) return;
    const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      const x = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max;
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * rtl }));
    next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * rtl }));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  // Review tag filter
  document.querySelectorAll('[data-reviews]').forEach((wrap) => {
    const tags = wrap.querySelectorAll('.tag');
    const cards = wrap.querySelectorAll('.card');
    tags.forEach((b) => b.addEventListener('click', () => {
      const was = b.classList.contains('on');
      tags.forEach((x) => x.classList.remove('on'));
      if (!was) b.classList.add('on');
      const label = b.textContent.trim();
      cards.forEach((c) => { c.hidden = !was && !c.dataset.tags.split('|').includes(label); });
    }));
  });

  // Research popup
  document.querySelectorAll('[data-open-research]').forEach((b) => b.addEventListener('click', (e) => {
    const dlg = document.querySelector('dialog.research');
    if (!dlg) return; // footer link falls back to the product page
    e.preventDefault();
    dlg.showModal();
  }));
  if (new URLSearchParams(location.search).has('research')) document.querySelector('dialog.research')?.showModal();
  document.querySelectorAll('dialog.research').forEach((d) => {
    d.querySelector('[data-close-research]')?.addEventListener('click', () => d.close());
    d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
  });

  // Mobile sticky CTA: show after the hero button scrolls away, hide while plans are on screen
  const sticky = document.querySelector('[data-m-sticky]');
  const heroBtn = document.getElementById('heroBtn');
  const plans = document.getElementById('plans');
  if (sticky && heroBtn && plans) {
    let pastHero = false;
    let plansVisible = false;
    const update = () => sticky.classList.toggle('show', pastHero && !plansVisible);
    new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; update(); }).observe(heroBtn);
    new IntersectionObserver(([e]) => { plansVisible = e.isIntersecting; update(); }, { threshold: 0.15 }).observe(plans);
  }

  // Expose the sticky header height so in-page sticky bars sit right under it.
  const topBar = document.querySelector('.top');
  if (topBar) {
    const setTopH = () => document.documentElement.style.setProperty('--dr-top-h', `${topBar.offsetHeight}px`);
    setTopH();
    new ResizeObserver(setTopH).observe(topBar);
  }

  // Pre-sell sticky button: hidden while the hero button is on screen
  const bwSticky = document.querySelector('.bw-sticky');
  const bwHeroCta = document.querySelector('.bw-hero .bw-cta');
  if (bwSticky && bwHeroCta) {
    new IntersectionObserver(([e]) => { bwSticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(bwHeroCta);
  }

  // Pre-sell review rail arrows
  document.querySelectorAll('[data-bw-rail]').forEach((rail) => {
    const sec = rail.closest('section');
    const step = () => Math.max(rail.clientWidth * 0.8, 260);
    sec?.querySelector('[data-bw-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    sec?.querySelector('[data-bw-next]')?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    const dots = sec?.querySelector('[data-bw-dots]');
    if (dots) {
      const pages = () => Math.max(1, Math.ceil(rail.scrollWidth / rail.clientWidth));
      const draw = () => {
        const n = pages();
        if (dots.childElementCount !== n) dots.innerHTML = '<i></i>'.repeat(n);
        const max = rail.scrollWidth - rail.clientWidth;
        const cur = max > 0 ? Math.round((rail.scrollLeft / max) * (n - 1)) : 0;
        [...dots.children].forEach((d, i) => d.classList.toggle('on', i === cur));
      };
      rail.addEventListener('scroll', draw, { passive: true });
      new ResizeObserver(draw).observe(rail);
      draw();
    }
  });

  // Research badge close (shows again on every page load)
  const trust = document.querySelector('[data-trust]');
  if (trust) {
    trust.querySelector('[data-trust-close]')?.addEventListener('click', () => {
      trust.hidden = true;
    });
  }

  // ===== Cart drawer (ColonBroom style) =====
  const cd = document.getElementById('dr-cart');
  if (cd) {
    const readJSON = (id, fb) => { try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return fb; } };
    const planData = readJSON('dr-plan-data', {});
    const giftData = readJSON('dr-gift-data', []);
    // Real $0 gift products: kept in the cart only while it holds a subscription, so they show in checkout and on the order.
    const giftLines = readJSON('dr-gift-lines', []).filter((g) => g && g.id);
    const giftIds = new Set(giftLines.map((g) => Number(g.id)));
    // Retired gifts (Workout Plan, Recipe Guide PDFs) are removed from carts that still hold them.
    const retiredGiftIds = new Set([57582661861702, 57582661927238]);
    const isGift = (it) => giftIds.has(Number(it.variant_id)) || retiredGiftIds.has(Number(it.variant_id)) || !!(it.properties && it.properties._gift);
    // Bonus lines (e.g. $30 gift card, e-book) kept in the cart while it holds one of their qualifying bundles.
    // Each line stores the bundles it belongs to in _bonus_for, so pages of other products leave it alone.
    const bonusRaw = readJSON('dr-bonus', []);
    const bonuses = (Array.isArray(bonusRaw) ? bonusRaw : [bonusRaw]).filter((b) => b && b.id);
    const isBonus = (it) => !!(it.properties && it.properties._bonus);
    // Optional order protection line (cart toggle); never counted as a product or shown in the item list.
    const opEl = cd.querySelector('[data-cd-op]');
    const opId = opEl ? Number(opEl.dataset.id) : 0;
    const isOp = (it) => !!opId && Number(it.variant_id) === opId;
    const pageBonus = (it) => bonuses.find((b) => Number(b.id) === Number(it.variant_id));
    const bonusTargets = (it) => {
      const own = it.properties && it.properties._bonus_for;
      if (own) return String(own).split(',').map(Number);
      const b = pageBonus(it);
      return b ? b.for.map(Number) : null;
    };
    const bonusItem = (b) => ({ id: Number(b.id), quantity: 1, properties: { _bonus: 'gift', _bonus_for: b.for.join(',') } });
    // Gift lines go through an untracked fetch so the pixel reports one AddToCart (Daily Fiber), not one per $0 gift.
    let rawFetch = null;
    const giftFetch = (url, opts) => {
      giftFetch.warm();
      return rawFetch(new URL(url, location.origin).href, opts);
    };
    giftFetch.warm = () => {
      if (!rawFetch) {
        try {
          const fr = document.createElement('iframe');
          fr.hidden = true;
          fr.setAttribute('aria-hidden', 'true');
          fr.tabIndex = -1;
          document.body.appendChild(fr);
          rawFetch = fr.contentWindow.fetch.bind(fr.contentWindow);
        } catch (e) { rawFetch = fetch; }
      }
    };
    const addGifts = (list) => giftFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list.map((g) => ({ id: Number(g.id), quantity: 1, properties: { _gift: 'subscription' } })).reverse() }) });
    if (giftLines.length) (window.requestIdleCallback || setTimeout)(() => { try { giftFetch.warm(); } catch (e) {} });
    let syncing = false;
    const syncGifts = async (cart) => {
      if (syncing) return false;
      const main = cart.items.filter((it) => !isGift(it) && !isBonus(it) && !isOp(it));
      const hasSub = main.some((it) => it.selling_plan_allocation);
      const updates = {};
      cart.items.filter(isGift).forEach((it) => {
        if (retiredGiftIds.has(Number(it.variant_id))) updates[it.key] = 0;
        else if (!hasSub || it.quantity !== 1) updates[it.key] = hasSub ? 1 : 0;
      });
      const missing = hasSub ? giftLines.filter((g) => !cart.items.some((it) => Number(it.variant_id) === Number(g.id))) : [];
      const mainIds = new Set(main.map((it) => Number(it.variant_id)));
      cart.items.filter(isBonus).forEach((line) => {
        const targets = bonusTargets(line);
        if (!targets) return;
        const wants = targets.some((id) => mainIds.has(id));
        if (!wants || line.quantity !== 1) updates[line.key] = wants ? 1 : 0;
      });
      const addBonus = bonuses.filter((b) => b.for.some((id) => mainIds.has(Number(id))) && !cart.items.some((it) => isBonus(it) && Number(it.variant_id) === Number(b.id)));
      cart.items.filter(isOp).forEach((line) => { if (!main.length || line.quantity !== 1) updates[line.key] = main.length ? 1 : 0; });
      // Pre-ticked protection: added once per session unless the customer unticked it.
      let opChoice = '';
      try { opChoice = sessionStorage.getItem('dr_op_choice') || ''; } catch (e) {}
      const addOp = !!opEl && opEl.dataset.default === 'true' && main.length > 0 && opChoice !== 'off' && !cart.items.some(isOp);
      if (addOp) addBonus.push({ id: opId, op: true });
      if (!missing.length && !addBonus.length && !Object.keys(updates).length) return false;
      syncing = true;
      try {
        if (Object.keys(updates).length) await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
        if (missing.length) {
          await addGifts(missing);
        }
        if (addBonus.length) await giftFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: addBonus.map((b) => (b.op ? { id: b.id, quantity: 1 } : bonusItem(b))) }) });
      } catch (e) { /* keep the cart usable even if gift sync fails */ }
      syncing = false;
      return true;
    };
    const overlay = document.querySelector('.cd-overlay');
    const body = cd.querySelector('[data-cd-body]');
    let currency = 'USD';
    const money = (c) => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(c / 100);
    const esc = (t) => String(t ?? '').replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
    const banner = document.querySelector('.announce');
    const cdBanner = cd.querySelector('[data-cd-banner]');
    if (banner) cdBanner.innerHTML = banner.innerHTML;
    // While the hero's real sale end date is ahead, the cart banner counts down to it instead.
    const dealSrc = document.querySelector('.hb-deal[data-deal-end]');
    const dealEnd = dealSrc ? new Date(dealSrc.dataset.dealEnd).getTime() : NaN;
    if (dealSrc && dealEnd > Date.now()) {
      const label = dealSrc.firstChild?.textContent.trim() || 'Sale ends in';
      cdBanner.classList.add('is-deal');
      cdBanner.innerHTML = '<span aria-hidden="true">⏰</span> ' + esc(label) + ' <b data-cd-left></b>';
      const left = cdBanner.querySelector('[data-cd-left]');
      const pad = (v) => String(v).padStart(2, '0');
      const tick = () => {
        const t = Math.floor((dealEnd - Date.now()) / 1000);
        if (t <= 0) { clearInterval(dealTimer); cdBanner.classList.remove('is-deal'); cdBanner.innerHTML = banner ? banner.innerHTML : ''; return; }
        const d = Math.floor(t / 86400);
        const box = (v, u) => `<i>${v}<small>${u}</small></i>`;
        left.innerHTML = (d ? box(d, 'd') : '') + box(pad(Math.floor(t / 3600) % 24), 'h') + box(pad(Math.floor(t / 60) % 60), 'm') + box(pad(t % 60), 's');
      };
      const dealTimer = setInterval(tick, 1000);
      tick();
    }

    const open = () => { cd.classList.add('open'); cd.setAttribute('aria-hidden', 'false'); overlay.hidden = false; document.documentElement.classList.add('cd-lock'); };
    const close = () => { cd.classList.remove('open'); cd.setAttribute('aria-hidden', 'true'); overlay.hidden = true; document.documentElement.classList.remove('cd-lock'); };
    document.querySelectorAll('[data-cd-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

    const render = async (cart) => {
      paint(cart);
      if (await syncGifts(cart)) { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); paint(await r.json()); }
    };
    const paint = (cart) => {
      currency = cart.currency || currency;
      const mainItems = cart.items.filter((it) => !isGift(it) && !isBonus(it) && !isOp(it));
      const count = mainItems.reduce((n, it) => n + it.quantity, 0);
      cd.querySelector('[data-cd-count]').textContent = String(count);
      document.querySelectorAll('[data-cd-open] .txt').forEach((t) => { t.textContent = `Cart (${count})`; });
      if (!mainItems.length) {
        body.innerHTML = '<p class="cd-empty">Your cart is empty.</p>';
        const pe = cd.querySelector('[data-cd-perks]'); if (pe) pe.hidden = true;
        cd.querySelector('[data-cd-total]').textContent = money(0);
        cd.querySelector('[data-cd-save]').hidden = true;
        return;
      }
      let compareTotal = 0;
      const items = mainItems.map((it) => {
        const pd = planData[it.variant_id] || {};
        const compare = (pd.compare || it.original_price) * it.quantity;
        compareTotal += Math.max(compare, it.final_line_price);
        // "Deliver every 4 weeks, 37% off" / "Delivery: every 3 months | 20% off" -> "every 4 weeks" / "every 3 months".
        const freq = it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name.split(/[,|]/)[0].replace(/^(delivery:|deliver)\s*/i, '').trim() : '';
        return `<div class="cd-item">
          <img src="${esc(pd.img || it.image)}" alt="" width="72" height="72">
          <div class="cd-info"><b>${esc(it.product_title)}</b><span class="cd-plan">${esc(pd.title || it.variant_title)}${it.quantity > 1 ? ' × ' + it.quantity : ''}</span>${freq ? `<span class="cd-plan2 cd-refill"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12a8 8 0 0 1-14.2 5M4 12a8 8 0 0 1 14.2-5"/><path d="M18 3v4h-4M6 21v-4h4"/></svg>Refills ${esc(freq)}</span><span class="cd-plan2 cd-refill-note">Subscribe &amp; save · Cancel anytime</span>` : '<span class="cd-plan2">One-time purchase</span>'}
            <span class="cd-price"><b>${money(it.final_line_price)}</b>${compare > it.final_line_price ? `<s>${money(compare)}</s>` : ''}</span></div>
          <button type="button" class="cd-rm" data-key="${esc(it.key)}" aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg></button>
        </div>`;
      }).join('');
      const hasSub = mainItems.some((it) => it.selling_plan_allocation);
      const gifts = (hasSub ? (giftLines.length ? giftLines : giftData) : []).map((g) => `<div class="cd-item cd-gift">${g.img ? `<img src="${esc(g.img)}" alt="" width="72" height="72">` : '<span></span>'}<div class="cd-info"><b>${esc(g.title)}</b><span class="cd-plan">Free with your subscription</span><span class="cd-price"><b class="cd-free">FREE</b></span></div></div>`).join('');
      const bonusRow = cart.items.filter(isBonus).map((it) => {
        const b = pageBonus(it) || {};
        const img = b.img || it.image;
        return `<div class="cd-item cd-gift">${img ? `<img src="${esc(img)}" alt="" width="72" height="72">` : '<span></span>'}<div class="cd-info"><b>${esc(b.title || it.product_title)}</b><span class="cd-plan">${esc(b.note || '')}</span><span class="cd-price"><b class="cd-free">FREE</b></span></div></div>`;
      }).join('');
      const freeShip = window.drFreeShip && window.drFreeShip.active;
      const ship = `<div class="cd-item cd-ship"><span class="cd-ship-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 7h11v9H2z"/><path d="M13 10h4l3 3v3h-7"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="16.5" cy="17.5" r="1.8"/></svg></span><div class="cd-info"><b>Shipping</b><span class="cd-price">${freeShip ? '<b class="cd-free">FREE</b><s>$10.00</s>' : '<b>$10.00</b>'}</span></div></div>`;
      const extras = bonusRow + gifts;
      // Unlocked perks for this cart (all real: free shipping, subscription discount, gifts in the cart).
      const perksEl = cd.querySelector('[data-cd-perks]');
      if (perksEl) {
        const giftCount = cart.items.filter((it) => isBonus(it) || isGift(it)).length;
        const subPct = mainItems.map((it) => it.selling_plan_allocation && it.selling_plan_allocation.selling_plan.price_adjustments[0]).filter((a) => a && a.value_type === 'percentage').map((a) => Math.round(a.value))[0];
        const perks = [];
        if (freeShip) perks.push('FREE shipping');
        if (subPct) perks.push(`${subPct}% off subscription`);
        if (giftCount) perks.push(giftCount === 1 ? '1 FREE gift' : `${giftCount} FREE gifts`);
        perksEl.innerHTML = perks.length ? `<span class="cd-perks-t">Unlocked:</span>${perks.map((p) => `<span class="cd-perk"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12.5l4 4 8-9" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>${esc(p)}</span>`).join('')}` : '';
        perksEl.hidden = !perks.length;
      }
      // Free shipping is shown in the shipping-day box below; the row only appears when shipping is charged.
      body.innerHTML = items + (extras ? `<div class="cd-sep"></div>${extras}` : '') + (!freeShip ? `<div class="cd-sep"></div>${ship}` : '');
      body.querySelectorAll('.cd-rm').forEach((b) => b.addEventListener('click', async () => {
        b.disabled = true;
        const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.key, quantity: 0 }) });
        await render(await r.json());
      }));
      const opLine = cart.items.find(isOp);
      const opCost = opLine ? opLine.final_line_price : 0;
      if (opEl) {
        // Pre-ticked protection shows as on right away, before the background sync adds the line.
        let opChoice = '';
        try { opChoice = sessionStorage.getItem('dr_op_choice') || ''; } catch (e) {}
        const opPending = opEl.dataset.default === 'true' && opChoice !== 'off' && mainItems.length > 0;
        opEl.querySelector('[data-cd-op-input]').checked = !!opLine || opPending;
      }
      // Discount codes already applied to the cart session (e.g. the claimed pop-up code): Shopify includes
      // them in cart.total_price, so the row only shows the code and its amount.
      const codeEl = cd.querySelector('[data-cd-code]');
      let codeOff = 0;
      let codeTitle = '';
      (cart.cart_level_discount_applications || []).forEach((a) => { if (a.type === 'discount_code') { codeOff += a.total_allocated_amount; codeTitle = codeTitle || a.title; } });
      cart.items.forEach((it) => (it.line_level_discount_allocations || []).forEach((d) => {
        if (d.discount_application && d.discount_application.type === 'discount_code') { codeOff += d.amount; codeTitle = codeTitle || d.discount_application.title; }
      }));
      const codeOn = !!codeEl && codeOff > 0;
      if (codeEl) {
        codeEl.hidden = !codeOn;
        if (codeOn) {
          const tag = codeEl.querySelector('.cd-code-tag');
          const svg = tag.querySelector('svg');
          const same = codeTitle.toUpperCase() === String(codeEl.dataset.code).toUpperCase();
          tag.textContent = (codeTitle || codeEl.dataset.code).toUpperCase() + ' ';
          if (svg) tag.prepend(svg);
          if (same) { const sm = document.createElement('small'); sm.textContent = `−${codeEl.dataset.percent}%`; tag.append(sm); }
        }
      }
      const save = compareTotal - (cart.total_price - opCost);
      const saveEl = cd.querySelector('[data-cd-save]');
      saveEl.hidden = save <= 0;
      saveEl.textContent = `You save ${money(save)}`;
      // Show the amount the customer will actually pay: products + the shipping shown above.
      const opPendingCost = opEl && !opLine && opEl.querySelector('[data-cd-op-input]').checked ? Number(opEl.dataset.price || 0) : 0;
      if (codeOn) codeEl.querySelector('[data-cd-code-amount]').textContent = '−' + money(codeOff);
      cd.querySelector('[data-cd-total]').textContent = money(cart.total_price + opPendingCost + (freeShip ? 0 : 1000));
      const co = cd.querySelector('.cd-checkout');
      let offerCode = '';
      try { offerCode = sessionStorage.getItem('dr_offer_code') || ''; } catch (e) {}
      const codes = [freeShip && window.drFreeShip.code, offerCode].filter(Boolean);
      co.href = codes.length ? `/checkout?discount=${codes.map(encodeURIComponent).join(',')}` : '/checkout';
    };
    document.addEventListener('dr:freeship', () => { if (cd.classList.contains('open')) refresh(); });
    const refresh = async () => { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); await render(await r.json()); };
    document.addEventListener('dr:offer-claimed', () => { refresh().catch(() => {}); });
    if (opEl) {
      const opInput = opEl.querySelector('[data-cd-op-input]');
      opInput.addEventListener('change', async () => {
        opInput.disabled = true;
        try {
          const cur = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
          const line = cur.items.find(isOp);
          if (opInput.checked && !line) await giftFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: opId, quantity: 1 }] }) });
          if (!opInput.checked && line) await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
          try { sessionStorage.setItem('dr_op_choice', opInput.checked ? 'on' : 'off'); } catch (e) {}
        } catch (e) { /* keep the cart usable */ }
        opInput.disabled = false;
        await refresh();
      });
    }

    document.querySelectorAll('[data-cd-open]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); refresh(); open(); }));
    if (location.hash === '#cart') { history.replaceState(null, '', location.pathname + location.search); refresh(); open(); }
    document.querySelectorAll('[data-plan-form]').forEach((f) => f.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = f.querySelector('button');
      btn?.setAttribute('aria-busy', 'true');
      open();
      body.innerHTML = '<p class="cd-empty cd-loading">Adding to your cart…</p>';
      const fd = new FormData(f);
      const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
      if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
      try {
        // Gifts first, product last: Shopify lists the newest line first, so Daily Fiber stays on top in checkout.
        // Gifts already in the cart are brought back to quantity 1 by syncGifts.
        if (item.selling_plan && giftLines.length) await addGifts(giftLines);
        const wanted = bonuses.filter((b) => b.for.map(Number).includes(item.id));
        if (wanted.length) {
          const cur = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
          const toAdd = wanted.filter((b) => !cur.items.some((it) => isBonus(it) && Number(it.variant_id) === Number(b.id)));
          if (toAdd.length) await giftFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: toAdd.map(bonusItem) }) });
        }
        if (opEl && opEl.dataset.default === 'true') {
          let choice = '';
          try { choice = sessionStorage.getItem('dr_op_choice') || ''; } catch (e) {}
          const cur = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
          if (choice !== 'off' && !cur.items.some(isOp)) await giftFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: opId, quantity: 1 }] }) });
        }
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
        if (!r.ok) throw new Error('add failed');
        await refresh();
      } catch (err) {
        f.submit();
      } finally {
        btn?.removeAttribute('aria-busy');
      }
    }));
  }
})();

// Featured review: clamp the quote to a few lines with a Read more toggle when it overflows.
document.querySelectorAll('.hb-review').forEach((card) => {
  const quote = card.querySelector('blockquote');
  const more = card.querySelector('[data-rv-more]');
  if (!quote || !more) return;
  card.classList.add('is-clamped');
  if (quote.scrollHeight <= quote.clientHeight + 2) { card.classList.remove('is-clamped'); return; }
  more.hidden = false;
  more.addEventListener('click', () => {
    const open = card.classList.toggle('is-clamped') === false;
    more.setAttribute('aria-expanded', String(open));
    more.textContent = open ? 'Read less' : 'Read more';
  });
});

// Discount offer slide-up: once per visit, after the bundle picker has been on screen for a while
// without an add to cart (or on exit intent on desktop). Claiming attaches the code to the session.
(() => {
  const box = document.querySelector('[data-dr-offer]');
  if (!box) return;
  const code = box.dataset.code;
  const KEY = 'dr_offer_state';
  let state = '';
  try { state = sessionStorage.getItem(KEY) || ''; } catch (e) {}
  if (state) return;
  const remember = (v) => { try { sessionStorage.setItem(KEY, v); } catch (e) {} };
  const delay = (parseInt(box.dataset.delay, 10) || 15) * 1000;
  let shown = false;
  let added = false;
  let seen = 0;
  let last = 0;
  let visible = false;
  const show = () => {
    if (shown || added || document.querySelector('.cd.open')) return;
    shown = true;
    box.hidden = false;
    requestAnimationFrame(() => box.classList.add('is-in'));
    remember('shown');
  };
  const hide = () => { box.classList.remove('is-in'); setTimeout(() => { box.hidden = true; }, 300); };
  const form = document.querySelector('.hb-form');
  if (form) {
    form.addEventListener('submit', () => { added = true; }, true);
    // Counts while any meaningful part of the bundle picker is on screen (it can be taller than the window on desktop).
    const io = new IntersectionObserver((entries) => { visible = entries.some((en) => en.isIntersecting && en.intersectionRect.height >= Math.min(200, en.boundingClientRect.height * 0.25)); last = performance.now(); }, { threshold: [0, 0.1, 0.2, 0.3, 0.5] });
    io.observe(form);
    const tick = () => {
      if (shown || added) return;
      const now = performance.now();
      if (visible && !document.hidden) seen += now - last;
      last = now;
      // Fallback: anyone still on the page after the delay plus 20 s without adding to cart.
      if (seen >= delay || now - startedAt >= delay + 20000) { show(); return; }
      setTimeout(tick, 500);
    };
    last = performance.now();
    const startedAt = last;
    setTimeout(tick, 500);
  }
  document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY <= 0 && performance.now() > 8000) show(); });
  box.querySelectorAll('[data-offer-close]').forEach((b) => b.addEventListener('click', () => { remember('closed'); hide(); }));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && shown && !box.hidden) { remember('closed'); hide(); } });
  const claim = box.querySelector('[data-offer-claim]');
  claim?.addEventListener('click', async () => {
    claim.disabled = true;
    try { await fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }); } catch (e) {}
    remember('claimed');
    try { sessionStorage.setItem('dr_offer_code', code); } catch (e) {}
    box.querySelector('.dr-offer-actions').hidden = true;
    box.querySelector('[data-offer-text]').hidden = true;
    box.querySelector('[data-offer-done]').hidden = false;
    document.dispatchEvent(new CustomEvent('dr:offer-claimed', { detail: { code } }));
    setTimeout(hide, 3500);
  });
})();
